import React, { Component } from "react";
import moment from "moment";

class ConnectedLessons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    console.log(props);
  }

  timeFrame(from, to) {
    let lesson_date = moment(from).format("DD.MM.YYYY");
    let time_from = moment(from).format("HH:mm");
    let time_to = moment(to).format("HH:mm");
    return (
      <div className="flex justify-start">
        <div className="w-[95px]">{lesson_date}</div>
        <div className="">
          | {time_from} - {time_to}
        </div>
      </div>
    );
  }

  toggleOpen = () => {
    this.setState({ open: !this.state.open });
  };

  render() {
    return (
      <div>
        <span
          className="text-info underline cursor-pointer"
          onClick={this.toggleOpen}
        >
          {this.state.open === true ? "Kurszeiten ausblenden" : "Kurszeiten anzeigen"}
        </span>
        {this.state.open && (
          <div className="pt-2">
            {this.props.lesson !== undefined ? this.timeFrame(
              this.props.lesson.planned_from,
              this.props.lesson.planned_to
            ) : null}
            {this.props.lessons.map((lesson) => {
              return this.timeFrame(lesson.planned_from, lesson.planned_to);
            })}
          </div>
        )}
      </div>
    );
  }
}

export default ConnectedLessons;
